<template>
    <div class="accordion interment-item-wrapper">
        <div class="card">
            <div class="card-header" :id="`heading-interment-${indexItem}`">
                <button
                    type="button"
                    class="btn btn-link btn-block interment-header"
                    aria-expanded="false"
                    data-toggle="collapse"
                    :data-target="`#collapse-interment-${indexItem}`"
                    :aria-controls="`#collapse-interment-${indexItem}`">
                    <div class="interment-panel-desc">
                        <i class="fas fa-chevron-right"></i>
                    </div>
                    <div class="up-to-3-entities">
                        <div class="divider" style="display: none;"></div>
                        <div class="entity-info">
                            <div class="container-name-label">
                                <h3 class="entity-full-name">
                                    <span>{{ entityName }}</span>
                                </h3>
                                <div>
                                    <div class="container-icons">
                                    </div>
                                </div>
                            </div>
                            <p class="entity-dates-age">
                                {{ entityDatesAge }}
                            </p>
                        </div>
                    </div>
                </button>
            </div>
            <div
                :id="`collapse-interment-${indexItem}`"
                class="collapse"
                :aria-labelledby="`heading-interment-${indexItem}`">
                <div class="card-body">
                    <!-- <div class="interment-date">
                        <span class="interment-date-title">{{ $t(`${modelTranslateID}.interment_at`) }}:</span>{{ intermentAt }}
                    </div> -->

                    <div class="interment-item-content">
                        <div class="type_gender_serviceman">
                            <p class="type">
                                <img loading="lazy" :src="intermentTypeIcon" alt="">
                                <span>{{ intermentTypeName }}</span>
                            </p>
                            <p class="gender">
                                <img loading="lazy" :src="entityGenderIcon" alt="">
                                <span>{{ entityGender }}</span>
                            </p>
                        </div>

                        <div class="common-info">
                            <ul>
                                <template v-for="(item, idx) in commonInfo">
                                    <li
                                        v-if="itemInfo(item)"
                                        :key="`interment-item-common-${indexItem}-${idx}`"
                                        :class="item"
                                        >
                                        <label class="pr-2">{{ $t(`${modelTranslateID}.interment.${item}`) }}:</label>{{ itemInfo(item) }}
                                    </li>
                                </template>
                            </ul>
                        </div>

                        <button
                            v-if="allowViewDetail"
                            class="btn view-interment"
                            @click.prevent="onViewDetail">
                            <i class="far fa-user" ></i>
                            <span>{{ $t(`${baseTranslateID}.buttons.interment.view`) }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
import { EVENTS } from '../../../shared/config/event-constants';
import { apiConstants } from '../../../shared/config/api-constants';
import { dotNotation } from '@config/utils';

export default {
    mixins: [
        CemeteryElementMixin
    ],
    components: {
    },
    props: {
        indexItem: {
            type: Number,
            default: 0,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        eventIntermentViewDetail: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_INTERMENT,
        },
    },
    data() {
        return {
            commonInfo: [
                'entity.religion',
                'entity.occupation',
                'entity.cause_death',
                'entity.full_address',

                'interment_at',
                'interment_depth',
                // 'interment.cremation_location',
            ]
        }
    },
    computed: {
        allowViewDetail() {
            return this.actions?.interment?.detail;
        },
        valueDotNotation() {
            return dotNotation(this.value);
        },
        modelTranslateID() {
            return `${this.baseTranslateID}.model`
        },
        interment() {
            return this.value ?? {};
        },
        entity() {
            return this.interment?.entity ?? {};
        },
        intermentType() {
            return this.interment?.interment_type ?? {};
        },
        intermentTypeName() {
            return this.intermentType?.name
        },
        intermentTypeIcon() {
            let icon = this.$root.$helper.theme.assetsPathModule(apiConstants.module, 'interment-unspecified.svg');
            let code = this.intermentType?.code?.toLowerCase();
            if(code) {
                icon = this.$root.$helper.theme.assetsPathModule(apiConstants.module, `interment-${code}.svg`);
            }
            return icon;
        },
        intermentAt() {
            let val = this.interment?.interment_at;
            return val ? moment(val).format(this.labelDateFormat) : null;
        },
        entityName() {
            return this.entity?.name;
        },
        entityDatesAge() {
            // 06/03/1927 - 07/10/1966 (39 y.o)
            let txtDates = '';
            let birth_at = this.entity.birth_at ?? null;
            let death_at = this.entity.death_at ?? null;
            let age = this.entity.age ?? 'n/a';

            if(birth_at || death_at) {
                txtDates += `${birth_at ?? 'n/a'} - ${death_at ?? 'n/a'}`
            }else{
                txtDates += 'n/a';
            }

            if(age) {
                txtDates += ` (${age} ${this.$t(`${this.modelTranslateID}.interment.years`).toLowerCase()})`
            }
            return txtDates;
        },
        entityGender() {
            return this.entity?.gender?.name;
        },
        entityGenderIcon() {
            let icon = this.$root.$helper.theme.assetsPathModule(apiConstants.module, 'gender-unspecified.svg');
            let code = this.entity?.gender?.code?.toLowerCase();
            if(code) {
                icon = this.$root.$helper.theme.assetsPathModule(apiConstants.module, `gender-${code}.svg`);
            }
            return icon;
        },
    },
    methods: {
        reset() {
            // [TODO]
            // let el = this.$refs.intermentHeader;
            // if(el) {
            //     console.log($(el))
            //     $(el).collapse(this.expanded ? 'show': 'hide');
            // }
        },
        itemInfo(key) {
            return this.valueDotNotation[key];
        },
        onViewDetail() {
            if(!this.allowViewDetail) return;

            if(this.eventIntermentViewDetail) {
                this.$eventBus.publish(this.moduleCode, this.eventIntermentViewDetail, {data: {...this.interment}});
            }
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function(value, oldValue) {
                this.reset();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .interment-item-wrapper {
        .card {
            border: 1px solid rgba(24, 20, 41, .2) !important;
            border-radius: 8px;

            .card-header {
                margin: 0;
                padding: 0;
                border-bottom: none;
                background-color: transparent;

                .btn {
                    min-width: auto;
                    background-color: #fff;
                    padding: 16px;

                    &:focus,
                    &:hover {
                        outline: 0;
                        box-shadow: none;
                        text-decoration: none;
                    }

                    &:hover:not([aria-expanded=true]) {
                        background: rgba(0, 0, 0, .04);
                    }
                }
            }

            .card-body {
                padding-top: 0;
            }
        }

        .interment-header {
            display: flex;
            flex-direction: row-reverse;
            flex: 1;
            overflow: hidden;

            .interment-panel-desc {
                margin-right: 0;
                flex-grow: 2;
                display: flex;
                color: var(--primary-color);
                font-size: 17px;
                cursor: pointer;

                i {
                    width: 24px;
                    height: 24px;
                }
            }

            &[aria-expanded=true] {
                .interment-panel-desc {
                    display: none;
                }
            }

            .up-to-3-entities {
                display: flex;
                min-height: 52px;
                width: 100%;

                .divider {
                    width: 4px;
                    border-top-right-radius: 50%;
                    border-bottom-right-radius: 50%;
                    background-color: rgba(103, 58, 183, .6);
                    margin-right: 12px;
                }

                .entity-info {
                    width: 100%;
                    text-align: left;

                    .container-name-label {
                        display: flex;
                        justify-content: flex-start;
                        gap: 8px;
                        align-items: center;
                        width: 100%;
                    }

                    .entity-full-name {
                        color: #181429;
                        margin-bottom: 0;
                        font-family: var(--city-medium-font-family);
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 24px;
                        text-transform: capitalize;
                    }

                    .entity-dates-age {
                        color: #181429;
                        opacity: .6;
                        font-size: 15px;
                        font-family: var(--city-font-family);
                        line-height: 20px;
                        margin-bottom: 0;
                        font-weight: 400;
                    }
                }
            }
        }

        .interment-date {
            color: #181429;
            font-size: 16px;
            line-height: 24px;
            font-family: var(--city-font-family);
            font-weight: 400;
        }

        .interment-date-title {
            opacity: .6;
            padding-right: 5px;
        }

        .interment-item-content {
            p {
                margin: 0 0 12px;
            }

            .type_gender_serviceman {
                display: flex;
                flex-wrap: wrap;

                .type,
                .gender {
                    margin-right: 14px;
                    min-width: 50px;
                    color: rgba(24, 20, 41, .5);
                    font-size: 14px;
                    line-height: 16px;
                    display: flex;
                    align-items: center;
                    flex-wrap: nowrap;
                }

                img {
                    margin-right: 7px;
                    opacity: .5;
                }

            }

            .common-info{
                ul {
                    list-style: none;
                    font-size: 16px;
                    line-height: 24px;
                    padding: 0;
                    margin: 0;

                    li {
                        margin-bottom: 8px;
                        color: rgb(24, 20, 41);

                        label {
                            color: rgba(24, 20, 41, .6);
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .view-interment {
                width: 100%;
                height: 40px;
                font-size: 14px;
                line-height: 16px;
                color: var(--primary-color);
                text-transform: uppercase;
                border: 1px solid currentColor;
                border-color: rgba(0, 0, 0, .12);
                box-shadow: 0 0 0 0 rgba(0, 0, 0, .2), 0 0 0 0 rgba(0, 0, 0, .14), 0 0 0 0 rgba(0, 0, 0, .12);
                margin: 0;
                padding: 0 15px;
                background: transparent;
                min-width: auto;

                i {
                    margin-right: 10px;
                }

                &:focus,
                &:hover {
                    outline: 0;
                    box-shadow: none;
                    text-decoration: none;
                    background: rgba(0, 0, 0, .04);
                }
            }
        }

    }
</style>